import { DEFAULT_WORKSPACE_SETTINGS } from '~api/workspaces/types';

import { useGetWorkspaceSettings } from '~teacher/hook/workspaces/useGetWorkspaceSettings';

/**
 * True when the library is an Official (read-only) library — content-mutating
 * actions (edit / create / delete / move / duplicate / merge / rename folder)
 * are locked for everyone until an Admin/Owner turns it off. Mirrors the
 * backend enforcement in `validateWorkspacePermissions` so the menu items are
 * disabled rather than failing on click.
 */
export function useIsWorkspaceReadOnly(workspaceId: string): boolean {
  const { data } = useGetWorkspaceSettings({ workspaceId });
  return (data ?? DEFAULT_WORKSPACE_SETTINGS).readOnlyMode !== 'off';
}
